import { isMobile } from '../../../utilities/General';

export function playSuccessAnimation() {
	if (gsap === 'undefined') {
		console.error('GSAP is undefined.');
		return;
	}

	gsap.registerPlugin(SplitText);

	const successElement = document.querySelector(
		'.wp-block-cancan-card-registration .cr-success'
	);
	const formWrapper = document.querySelector(
		'.wp-block-cancan-card-registration .form__wrapper'
	);
	const cardSVG = successElement.querySelector(
		'.cr-success-card__wrapper svg g.card'
	);

	const successText = successElement.querySelector('.cr-success__title');

	const successSplit = SplitText.create(successText, {
		type: 'words',
	});

	gsap.set(formWrapper, { display: 'none', visibility: 'hidden' });
	gsap.set(successElement, { visibility: 'visible', height: 'auto' });
	gsap.set(cardSVG, { transformOrigin: 'center center' });

	if (isMobile()) {
		successElement.scrollIntoView({ behavior: 'instant', block: 'center' });
	}

	let tl = gsap.timeline();

	tl.from(cardSVG, {
		scale: '0',
		ease: 'back.out',
		rotation: '-40',
		duration: '0.7',
	}).from(
		successSplit.words,
		{
			opacity: 0,
			y: 50,
			duration: 0.5,
			stagger: 0.1,
			ease: 'power2.out',
		},
		'<0.3'
	);
}
